import { LeadsService } from "./leads.service";
import { FeaturesService } from "./features.service";
import { MetaService } from "./meta.service";
import { AuthenticationService } from "./authentication.service";
import { AuthGuardService } from "./auth-guard.service";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { ModulesService } from "./modules.service";
import { HelperService } from "./helper.service";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireDatabaseModule } from "@angular/fire/compat/database";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { FeaturesComponent } from "./features/features.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { ModulesDisplayComponent } from "./modules-display/modules-display.component";
import { TechnologyComponent } from "./technology/technology.component";
import { PricingComponent } from "./pricing/pricing.component";
import { DocumentationComponent } from "./documentation/documentation.component";
import { MarkdownModule } from "ngx-markdown";
import { FormsModule } from "@angular/forms";
import "prismjs";
import "prismjs/components/prism-typescript.min.js";
import "prismjs/plugins/line-numbers/prism-line-numbers.js";
import "prismjs/plugins/line-highlight/prism-line-highlight.js";
import { ModulesComponent } from "./modules/modules.component";
import { SecurityComponent } from "./security/security.component";
import { GovernmentComponent } from "./government/government.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { GatekeeperComponent } from "./gatekeeper/gatekeeper.component";
import { CataloguesService } from "./catalogues.service";
import { RegulationsComponent } from "./regulations/regulations.component";
import { UtilitiesComponent } from "./utilities/utilities.component";
import { SmbComponent } from "./smb/smb.component";
import { FinancialComponent } from "./financial/financial.component";
import { PartnershipComponent } from "./partnership/partnership.component";
import { ContactComponent } from "./contact/contact.component";
import { TeamComponent } from "./team/team.component";
import { ViewerComponent } from "./viewer/viewer.component";
import { SafeUrlPipe } from "./safe-url.pipe";
import { ThankYouComponent } from "./thank-you/thank-you.component";
import { NotfoundComponent } from "./notfound/notfound.component";
import { AdminComponent } from "./admin/admin.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { LeadsComponent } from "./leads/leads.component";
import { CustomersComponent } from "./customers/customers.component";
import { LeadFormComponent } from "./lead-form/lead-form.component";
import { CustomerFormComponent } from "./customer-form/customer-form.component";
import { CustomerService } from "./customer.service";
import { PicklistsService } from "./picklists.service";
import { AngularFireStorageModule } from "@angular/fire/compat/storage";
import { PrivacyComponent } from "./privacy/privacy.component";
import { TosComponent } from "./tos/tos.component";
import { WhitepapersComponent } from "./whitepapers/whitepapers.component";
import { WhitepapersService } from "./whitepapers.service";
import { WebinarsComponent } from "./webinars/webinars.component";
import { WebinarsService } from "./webinars.service";
import { TrainingComponent } from "./training/training.component";
import { TrainingService } from "./training.service";
import { ManifestoComponent } from "./manifesto/manifesto.component";
import { RegopsComponent } from "./regops/regops.component";
import { RegistrationsComponent } from "./registrations/registrations.component";
import { RegistrationFormComponent } from "./registration-form/registration-form.component";
import { RegistrationService } from "./registration.service";
import { RegisterSelfServiceComponent } from "./register-self-service/register-self-service.component";
import { NextStepsComponent } from "./next-steps/next-steps.component";
import { HowWeHelpComponent } from "./how-we-help/how-we-help.component";
import { PartnerRegistrationComponent } from "./partner-registration/partner-registration.component";
import { PartnerListComponent } from "./partner-list/partner-list.component";
import { PartnerFormComponent } from "./partner-form/partner-form.component";
import { StatsComponent } from "./stats/stats.component";
import { ReadySetComponent } from "./ready-set/ready-set.component";
import { HowRegscaleWorksComponent } from "./how-regscale-works/how-regscale-works.component";
import { TestimonialsComponent } from "./testimonials/testimonials.component";
import { DiscoverDifferenceComponent } from "./discover-difference/discover-difference.component";
import { ComplianceChallengesComponent } from "./compliance-challenges/compliance-challenges.component";
import { ReduceRiskComponent } from "./reduce-risk/reduce-risk.component";
import { ShiftComplianceComponent } from "./shift-compliance/shift-compliance.component";
import { RegscaleSolutionComponent } from "./regscale-solution/regscale-solution.component";
import { ContinuousComplianceComponent } from "./continuous-compliance/continuous-compliance.component";
import { ContinuousComplianceBlueComponent } from "./continuous-compliance-blue/continuous-compliance-blue.component";
import { ContinuousComplianceEnergyComponent } from "./continuous-compliance-energy/continuous-compliance-energy.component";
import { GovernmentHeroComponent } from "./government-hero/government-hero.component";
import { FinancialHeroComponent } from "./financial-hero/financial-hero.component";
import { DigitalCoreComponent } from "./digital-core/digital-core.component";
import { MadeSimpleComponent } from "./made-simple/made-simple.component";
import { EnergyUtilitiesComponent } from "./energy-utilities/energy-utilities.component";
import { SwiperModule } from "swiper/angular";
import { EnsuringComplianceComponent } from "./ensuring-compliance/ensuring-compliance.component";
import { EnergyUtilitiesHeroComponent } from "./energy-utilities-hero/energy-utilities-hero.component";
import { ScaleWithBusinessComponent } from "./scale-with-business/scale-with-business.component";
import { ModuleCardsComponent } from "./module-cards/module-cards.component";
import { PurposefulFeaturesComponent } from "./purposeful-features/purposeful-features.component";
import { RethinkComplianceComponent } from "./rethink-compliance/rethink-compliance.component";
import { FeaturesCardsComponent } from "./features-cards/features-cards.component";
import { ContinuousComplianceSolutionsComponent } from "./compliance-solutions/compliance-solutions.component";
import { NextgenTechComponent } from "./nextgen-tech/nextgen-tech.component";
import { ItMattersComponent } from "./it-matters/it-matters.component";
import { PurposefullyDesignedComponent } from "./purposefully-designed/purposefully-designed.component";
import { PolymorphicDevComponent } from "./polymorphic-dev/polymorphic-dev.component";
import { MeetTechstackComponent } from "./meet-techstack/meet-techstack.component";
import { DataProtectionComponent } from "./nextgen-data/data-protection.component";
import { RegscaleDifferenceComponent } from "./regscale-difference/regscale-difference.component";
import { SecurityBlueComponent } from "./security-blue/security-blue.component";
import { AboutSecurityComponent } from "./about-security/about-security.component";
import { SecurityArchitectureComponent } from "./security-architecture/security-architecture.component";
import { PartnershipsComplianceComponent } from "./partnership-compliance/partnerships-compliance.component";
import { EnhancingSecurityComponent } from "./enhancing-security/enhancing-security.component";
import { FeaturedPartnersComponent } from "./featured-partners/featured-partners.component";
import { JoinMovementComponent } from "./join-movement/join-movement.component";
import { Ng2PageScrollModule } from "ng2-page-scroll";
import { RegscaleAllComponent } from "./regscale-all/regscale-all.component";
import { RegscaleDifference2Component } from "./regscale-difference2/regscale-difference2.component";
import { MoreThanLicenseComponent } from "./more-than-license/more-than-license.component";
import { AffordableOptionsComponent } from "./affordable-options/affordable-options.component";
import { PricingFeaturesComponent } from "./pricing-features/pricing-features.component";
import { FeaturedIntegrationsComponent } from "./featured-integrations/featured-integrations.component";
import { ProfessionalServicesComponent } from "./professional-services/professional-services.component";
import { ContactOrangeComponent } from "./contact-orange/contact-orange.component";
import { PartnershipsReimagine } from "./partnerships-reimagine/partnerships-reimagine.component";
import { ComplianceHeroComponent } from "./compliance-hero/compliance-hero.component";
import { JoinMovementContactComponent } from "./join-movement-contact/join-movement-contact.component";
import { LeadershipTeamComponent } from "./leadership-team/leadership-team.component";
import { HeadOfficeComponent } from "./head-office/head-office.component";
import { ScullyLibModule } from '@scullyio/ng-lib';
import { ReleaseNotesComponent } from './release-notes/release-notes.component';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { OscalComponent } from './oscal/oscal.component';
import { VitgComponent } from './vitg/vitg.component';
import { FedrampComponent } from './fedramp/fedramp.component';
import { TrainingTwoComponent } from './training-two/training-two.component';
import { TrainingAdminComponent } from './training-admin/training-admin.component';
import { TrainingPractitionerComponent } from './training-practitioner/training-practitioner.component';
import { TrainingAuditorComponent } from './training-auditor/training-auditor.component';
import { TrainingExecutiveComponent } from './training-executive/training-executive.component';
import { VideosService } from "./videos.service";
import { ComingsoonComponent } from './comingsoon/comingsoon.component';
import { TrainingRolesComponent } from './training-roles/training-roles.component';
import { RecentBlogsComponent } from './recent-blogs/recent-blogs.component';
import { BoardOfDirectorsComponent } from './board-of-directors/board-of-directors.component';
import { NewsFormComponent } from './news-form/news-form.component';
import { NewsListComponent } from './news-list/news-list.component';
import { PressComponent } from './press/press.component';
import { NewsService } from "./news.service";
import { MaterialRegScaleModule } from './material.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ProfilesComponent } from "./profiles/profiles.component";
import { OtherDownloadsComponent } from "./other-downloads/other-downloads.component";
import { DownloadService } from "./download.service";
import { SbomComponent } from "./sbom/sbom.component";

@NgModule({
	declarations: [
		AppComponent,
		HomeComponent,
		FeaturesComponent,
		ContactUsComponent,
		ModulesDisplayComponent,
		TechnologyComponent,
		PricingComponent,
		DocumentationComponent,
		ModulesComponent,
		SecurityComponent,
		GovernmentComponent,
		EnergyUtilitiesComponent,
		GatekeeperComponent,
		RegulationsComponent,
		UtilitiesComponent,
		SmbComponent,
		FinancialComponent,
		PartnershipComponent,
		ContactComponent,
		TeamComponent,
		ViewerComponent,
		SafeUrlPipe,
		ThankYouComponent,
		NotfoundComponent,
		AdminComponent,
		DashboardComponent,
		LeadsComponent,
		CustomersComponent,
		LeadFormComponent,
		CustomerFormComponent,
		PrivacyComponent,
		TosComponent,
		WhitepapersComponent,
		WebinarsComponent,
		TrainingComponent,
		ManifestoComponent,
		RegopsComponent,
		RegistrationsComponent,
		RegistrationFormComponent,
		RegisterSelfServiceComponent,
		NextStepsComponent,
		HowWeHelpComponent,
		PartnerRegistrationComponent,
		PartnerListComponent,
		PartnerFormComponent,
		StatsComponent,
		ReadySetComponent,
		HowRegscaleWorksComponent,
		TestimonialsComponent,
		DiscoverDifferenceComponent,
		ComplianceChallengesComponent,
		ReduceRiskComponent,
		ShiftComplianceComponent,
		RegscaleSolutionComponent,
		ContinuousComplianceComponent,
		GovernmentHeroComponent,
		DigitalCoreComponent,
		ContinuousComplianceBlueComponent,
		MadeSimpleComponent,
		FinancialHeroComponent,
		ContinuousComplianceEnergyComponent,
		EnsuringComplianceComponent,
		EnergyUtilitiesHeroComponent,
		ScaleWithBusinessComponent,
		ModuleCardsComponent,
		PurposefulFeaturesComponent,
		RethinkComplianceComponent,
		FeaturesCardsComponent,
		ContinuousComplianceSolutionsComponent,
		NextgenTechComponent,
		ItMattersComponent,
		PurposefullyDesignedComponent,
		PolymorphicDevComponent,
		MeetTechstackComponent,
		DataProtectionComponent,
		RegscaleDifferenceComponent,
		SecurityBlueComponent,
		AboutSecurityComponent,
		SecurityArchitectureComponent,
		PartnershipsComplianceComponent,
		EnhancingSecurityComponent,
		FeaturedPartnersComponent,
		JoinMovementComponent,
		RegscaleAllComponent,
		RegscaleDifference2Component,
		MoreThanLicenseComponent,
		AffordableOptionsComponent,
		PricingFeaturesComponent,
		FeaturedIntegrationsComponent,
		ProfessionalServicesComponent,
		ContactOrangeComponent,
		PartnershipsReimagine,
		ComplianceHeroComponent,
		JoinMovementContactComponent,
		LeadershipTeamComponent,
		HeadOfficeComponent,
		ReleaseNotesComponent,
		OscalComponent,
		VitgComponent,
		FedrampComponent,
		TrainingTwoComponent,
		TrainingAdminComponent,
		TrainingPractitionerComponent,
		TrainingAuditorComponent,
		TrainingExecutiveComponent,
		ComingsoonComponent,
		TrainingRolesComponent,
		RecentBlogsComponent,
		BoardOfDirectorsComponent,
		NewsFormComponent,
		NewsListComponent,
		PressComponent,
		ProfilesComponent,
		OtherDownloadsComponent,
		SbomComponent
	],
	imports: [
		MaterialRegScaleModule,
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		HttpClientModule,
		FormsModule,
		AngularFireModule.initializeApp(environment.firebaseConfig),
		AngularFireDatabaseModule,
		AngularFireAuthModule,
		AngularFireStorageModule,
		MarkdownModule.forRoot({
			loader: HttpClient,
		}),
		NgbModule,
		SwiperModule,
		Ng2PageScrollModule,
		ScullyLibModule,
		GoogleTagManagerModule.forRoot({
			id: 'GTM-K5VH6D3'
		})
	],
	providers: [
		WhitepapersService,
		WebinarsService,
		TrainingService,
		ModulesService,
		LeadsService,
		CataloguesService,
		FeaturesService,
		MetaService,
		AuthenticationService,
		AuthGuardService,
		HelperService,
		CustomerService,
		PicklistsService,
		RegistrationService,
		VideosService,
		NewsService,
		DownloadService
	],
	bootstrap: [AppComponent],
})
export class AppModule { }
